import { useMemo } from 'react';
import { Permission, maskHasPermission } from '@ruta/shared';
import { useAuthStatus } from './useAuthStatus';

/**
 * Check if the current user has a specific permission.
 */
export function usePermission(permission: Permission): boolean {
  const { permissionMask } = useAuthStatus();

  return useMemo(() => {
    return maskHasPermission(permissionMask, permission);
  }, [permissionMask, permission]);
}

/**
 * Check if the current user has all of the specified permissions.
 */
export function usePermissions(permissions: Permission[]): boolean {
  const { permissionMask } = useAuthStatus();

  return useMemo(() => {
    return permissions.every(p => maskHasPermission(permissionMask, p));
  }, [permissionMask, permissions]);
}
